import { debug } from '../.debug.js';

const STAGGER_TIME = 16; // ~1 frame. 0ms also works, but this is safer.
let chain = Promise.resolve();

export function staggerAfsRequests(callback: () => void) {
  // Staggering prevents page from hanging upon first filter interaction
  // Single chain is for all AFS placements on the page
  chain = chain
    .then(
      () =>
        new Promise<void>((res) => {
          setTimeout(res, STAGGER_TIME);
        })
    )
    .then(callback)
    .catch((error: unknown) => {
      debug.message('Failed requesting ads!', error).error();
    }); // prevent chain break
}
